export const extractPathInfo = (resourcePath) => {
  const segments = resourcePath.split('/').filter(Boolean);
  const [resourceType, resourceId] = segments;

  const result = {
    resourceType
  };

  if (resourceType === 'applications') {
    result.businessId = resourceId;
  } else if (resourceType === 'accounts') {
    result.applicationId = resourceId;
  } else if (resourceType === 'quotes') {
    result.businessId = resourceId;
  } else if (resourceType === 'products') {
    result.businessId = resourceId;
  }

  return result;
};